<template>
    <div>
        <div v-if="_.get(config, 'search')" class="row py-5">
            <div class="offset-md-8 col-md-4">
                <form id="search-field">
                  <div class="form-group">
                      <label for="formGroupExampleInput" class="bmd-label-static">{{ $t('site.form-resource-search-brochure') }}</label>
                    <input v-model="search" type="text" class="form-control" id="formGroupExampleInput" placeholder="Start typing here">
                  </div>
                </form>
            </div>
           <!--  <div class="col-md-4">
                <div class="form-group form-group--arrow">
                    <label for="exampleSelect1" class="bmd-label-floating">Filter by type</label>
                    <select v-model="currentFilter" class="form-control" id="exampleSelect1">
                        <option v-for="option in filterOptions" :value="option">{{ option.text }}</option>
                    </select>
                  </div>
            </div> -->
        </div>
        <div v-if="_.isEmpty(filteredList)" class="row d-flex justify-content-center">
            <p class="alert alert-default"><i>{{ $t('site.resources-noresults') }}</i></p>
        </div>
        <div v-else class="row d-flex justify-content-center">

            <div v-for="asset in filteredList" :key="asset.type + asset.id" class="col-sm-6 col-xxl-3 col-md-4 mb-5">
                <a v-if="asset.link" :href="'//www.youtube.com/watch?v=' + (asset.link)" class="card card__hover box-shadow h-100 popup" >
                    <div class="card--header bg-primary text-white py-2 text-left px-2">
                        <h4 class="card--header__sm m-0">{{ $t('site.resources-video') }}</h4>
                    </div>
                    <div class="card--icon__play flex-shrink-0">
                        <img class="img-fluid w-100" :src="_.imgPath(asset.image, null, true)"  alt="Resource Video">
                    </div>
                    <div class="card-footer flex-grow-1">
                        <h4 class="text-color m-0">{{ _.chain(asset).get('name').value() }}</h4>
                    </div>
                </a>
                <a  v-if="asset.file"
                    v-on:click="openFilePath(asset)"
                    href="javascript:void(0)"
                    class="card card__hover box-shadow h-100" >
                    <div class="card--header bg-primary text-white py-2 text-left px-2">
                        <h4 class="card--header__sm m-0">{{ getResourceType(asset) }}</h4>
                    </div>
                    <div class="card--icon__download flex-grow-0">
                        <img class="img-fluid" :src="_.imgPath(asset.file, null, true)"  alt="Resource Download">
                    </div>
                    <div class="card-footer flex-grow-1">
                        <h4 class="text-color m-0">{{ _.chain(asset).get('file.name').replace(/_/g, ' ').value() }}</h4>
                    </div>
                </a>
            </div>
        </div>

        <!-- Modal -->
        <div class="modal fade"
            id="resource-modal"
            tabindex="-1"
            role="dialog"
            aria-labelledby="resource-modalLabel"
            aria-hidden="true">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content bg-white">
                    <div class="modal-header pb-0">
                        <h5 class="modal-title w-100 text-center" id="resource-modalLabel">{{ _.get(currentFile, 'name') }}</h5>
                        <button type="button" class="btn close" data-dismiss="modal" aria-label="Close">
                            <img src="/img/site/icons/close.svg" alt="Close modal">
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="message-wrapper_ box-shadow_">
                            <button id="btn-message" type="button" class="btn btn-group--message" ></button>
                            <div class="card card--message">
                                <div class="card-header">
                                    <h4 class="text-center text-yellow no-hover mb-0">
                                        {{ _.chain(currentFile).get('size', 0).parseInt().filesize().value() }}
                                    </h4>
                                </div>

                                <div class="card-body">
                                    <p v-if="message" class="alert alert-success" v-html="message"></p>
                                    <p v-else-if="error" class="alert alert-danger" v-html="error"></p>
                                    <p v-else v-html="$t('site.form-resource-download-helptext')"></p>
                                    <form-component
                                        :initialData="formData"
                                        :config="formConfig"
                                        :loading="loading"
                                        v-on:input="handleFormInput"
                                        v-on:error="handleFormError"
                                        ></form-component>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import M from 'moment';
import UtilsMixin from './UtilsMixin';
import FormComponent from './form/FormComponent';

export default {
    data() {
        return {
            search: null,
            message: null,
            error: null,
            loading: false,
            currentFilter: null,
            currentSort: null,
            currentFile: null,
            formData: {},
        }
    },

    created() {
        if (window.localStorage.getItem('resource-form-data')) {
            try {
                this.formData = JSON.parse(window.localStorage.getItem('resource-form-data'));
            } catch (err) {
                this.formData = {};
            }
        }
    },

    mounted() {
        this.$nextTick(() => {
            this.updateHash(window.location.hash);

            $('.popup').magnificPopup({
                disableOn: 700,
                type: 'iframe',
                mainClass: 'mfp-fade',
                removalDelay: 160,
                preloader: false,
                fixedContentPos: false,
            });
        })

        $(window).on('hashchange', (e) => {
            let hash = window.location.hash;
            this.updateHash(hash);
        })
    },

    props: ['initialData', 'config', 'sticky'],

    components: {
        FormComponent,
    },

    mixins: [UtilsMixin],

    watch: {

    },

    computed: {
        filteredList() {
            let list = _.chain(this.initialData)
                .get('resources')
                .filter(res => {
                    let pass = true;
                    if (pass && this.currentFilter) {
                        pass = this.currentFilter.test(res);
                    }

                    if (pass && this.search) {
                        pass = String(res.name).toLowerCase().indexOf(this.search.toLowerCase()) >= 0;
                    }

                    return pass;
                })
                // .sort(_.get(this.currentSort, 'sort', this.sortByPosition))
                .value();

            list = this.sortByPosition(list);

            // if (this.initialData.sticky && this.initialData.sticky.length > 0) {
            //     list = this.stickyFileName(list);
            // }

            return list;
        },

        resources() {
            return _.chain(this.initialData)
                .get('resources')
                .value();
        },

        formConfig() {
            return _.chain(this.initialData)
                .get('form')
                .set('btnLabel', 'Download')
                .set('showMessage', false)
                .value();
        },

        filterOptions() {
            return {
                All: { value: 'file-all', text: 'All', test: (item) => true },
                Downloads: { value: 'file-type-pdf', text: 'PDF Document', test: (item) => _.get(item, 'file') && _.get(item, 'type') == 'Downloads' },
                Brochures: { value: 'file-type-pdf', text: 'PDF Document', test: (item) => _.get(item, 'file') && _.get(item, 'type') == 'Brochures' },
                Certifications: { value: 'file-type-pdf', text: 'PDF Document', test: (item) => _.get(item, 'file') && _.get(item, 'type') == 'Certifications' },
                Reports: { value: 'file-type-pdf', text: 'PDF Document', test: (item) => _.get(item, 'file') && _.get(item, 'type') == 'Reports' },
                Images: { value: 'file-type-image', text: 'Image', test: (item) => _.get(item, 'image') },
                Videos: { value: 'file-type-video', text: 'Video', test: (item) => _.includes(['Youtube', 'Vimeo'], item.type) },
                // { value: 'file-recent', text: 'Recent', test: (item) => this.createDate(item.created_at).add(7, 'day').isAfter(M()) },
            }
        },

        sortOptions() {
            return [
                { value: 'date-asc', text: 'Date ASC', sort: (i1, i2) => this.createDate(i1.created_at).diff(this.createDate(i2.created_at)) },
                { value: 'date-desc', text: 'Date DESC', sort: (i1, i2) => - this.createDate(i1.created_at).diff(this.createDate(i2.created_at)) },
                { value: 'name-asc', text: 'Name ASC', sort: (i1, i2) => _.get(i1, 'file.name', '').localeCompare(_.get(i2, 'file.name', '')) },
                { value: 'name-desc', text: 'Name DESC', sort: (i1, i2) => - _.get(i1, 'file.name', '').localeCompare(_.get(i2, 'file.name', '')) },
            ]
        },

        readonly() {
            return _.get(this.config, 'readonly');
        },
    },

    methods: {

        //Non-video assets appear first, sorted by their position
        //Youtube and Vimeo videos appear at the end, sorted by their pivot.position
        sortByPosition(assets) {
            return _.chain(assets)
                .sortBy([
                    asset => _.includes(['Youtube', 'Vimeo'], asset.type) ? 1 : 0,
                    asset => _.includes(['Youtube', 'Vimeo'], asset.type) 
                        ? (_.get(asset, 'pivot.position') || 0)
                        : (asset.position || 0)
                ])
                .value();
        },

        //Sticky assets appear first, sorted by their position
        stickyFileName(assets) {
            const stickyList = [];
            const nonStickyList = [];

            // Create a map for sticky names with their index for sorting
            const stickyNameMap = new Map();
            this.initialData.sticky.forEach((sticky, index) => {
                const name = typeof sticky === 'string' ? sticky : sticky.name;
                stickyNameMap.set(name, index);
            });

            // Sort assets into sticky and non-sticky lists
            assets.forEach(asset => {
                let assetName; 
                
                if (asset.type != 'Youtube' && asset.type != 'Vimeo') {
                    assetName = _.get(asset, 'file.name') || _.get(asset, 'name', '');
                } else {
                    assetName = _.get(asset, 'url');
                }

                if (stickyNameMap.has(assetName)) {
                    // Add the sticky index for sorting later
                    stickyList.push({
                        asset: asset,
                        stickyIndex: stickyNameMap.get(assetName)
                    });
                } else {
                    nonStickyList.push(asset);
                }
            });

            // Sort sticky list by their original order in the config
            const sortedStickyList = stickyList
                .sort((a, b) => a.stickyIndex - b.stickyIndex)
                .map(item => item.asset);

            return [...sortedStickyList, ...nonStickyList];
        },
        
        createDate(date) {
            return M(date, 'YYYY-MM-DD hh:mm:ss');
        },

        getFilePath(file) {
            return this.readonly ? this._.filePath(file) + '#toolbar=0' : this._.filePath(file, true);
        },

        youtubeThumbnailPath(link) {
            return `https://img.youtube.com/vi/${link}/0.jpg`;
        },

        getResourceType(asset) {
            if (asset.type == 'Brochures') {
                return this.$t('site.resources-brochures');
            }
            if (asset.type == 'Downloads') {
                return this.$t('site.resources-downloads');
            }
            if (asset.type == 'Reports') {
                return this.$t('site.resources-reports');
            }
            if (asset.type == 'Certifications') {
                return this.$t('site.resources-certifications');
            }
        },

        updateHash(hash) {
            switch (hash) {
                case '#cat-video':
                    this.currentFilter = this.filterOptions['Videos'];
                    break;
                case '#cat-download':
                    this.currentFilter = this.filterOptions['Downloads'];
                    break;
                case '#cat-brochure':
                    this.currentFilter = this.filterOptions['Brochures'];
                    break;
                case '#cat-certification':
                    this.currentFilter = this.filterOptions['Certifications'];
                    break;
                case '#cat-report':
                    this.currentFilter = this.filterOptions['Reports'];
                    break;
                case '#cat-image':
                    this.currentFilter = this.filterOptions['Images'];
                    break;
                case '#cat-all':
                    this.currentFilter = null;
                    break;
                default:
                    // Handle empty hash or unknown hash - default to "all"
                    this.currentFilter = null;
                    hash = '#cat-all';
                    break;
            }

            $(`[role="tab"]`).removeClass('active');
            $(`[role="tab"][href="${hash}"]`).addClass('active');
            this.$forceUpdate();
        },

        openFilePath(asset) {
            let file = asset.file;
            let $form = $('#resource-form');
            $form.removeClass('was-validated');

            this.currentFile = file;
            this.message = null;
            this.error = null;

            if (asset.secured) {
                let resourceModal = $('#resource-modal');
                this.$nextTick(() => {
                    $('#resource-form-btn')
                })
                this.formData = {
                    filename: _.get(file, 'name'),
                }
                return resourceModal.modal('show');
            }

            return window.open(this.getFilePath(file), '_blank');
        },

        handleFormInput(res) {
            this.loading = true;
            window.localStorage.setItem('resource-form-data', JSON.stringify(res.data));

            return this.api.postData('/downloads', {}, {
                token_id: res.id,
                file: _.get(this.currentFile, 'id'),
            }).then((res) => {
                this.message = 'We have sent the file you requested to your email.';
            }).finally(() => {
                this.loading = false;
            })
        },

        handleFormError(err) {
            let res = _.get(err, 'response.data');
            let errors = _.chain(res).get('errors', [])
                .values()
                .flatMap(v => `<li>${v}</li>`)
                .join()
                .value();

            if (res) {
                this.error = `
                    <p>${res.message}</p>
                    <ul>${errors}</ul>
                `;
            } else {
                this.error = 'There is something wrong with the submission, please try again.';
            }
        },
    }
}
</script>

